import { OnInit } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import { MODULE_NAME } from '../../old-crazy-web-frontend/src/app';
import { SentryService } from './config/sentry.service';
import { TranslateService } from '@ngx-translate/core';
import { LeftMenuComponent } from './main/left-menu/left-menu.component';
import { ConfigService } from './config/config.service';
import { Ng1TranslateService } from './shared/ng1-translate.service';
import { CalendlyService } from './config/calendly.service';
import { TypeformService } from './shared/services/typeform.service';
import { LanguageService } from './shared/services/language.service';
import { getUserDetailsSelector } from './shared/user/user.reducer';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import * as localEn from '../assets/i18n/locale_en.json';
import * as localEs from '../assets/i18n/locale_es.json';
import { AlertPaymentService } from './shared/services/alert-payment.service';
import { environment } from '../environments/environment';
import { AmplitudeRouteListenerService } from 'app/shared/services/amplitude-route-listener.service';
var AppComponent = /** @class */ (function () {
    function AppComponent(upgrade, translateService, sentryService, configService, ng1TranslateService, calendlyService, survicateService, languageService, store, alertPaymentService, amplitudeRouteListenerService) {
        this.upgrade = upgrade;
        this.translateService = translateService;
        this.sentryService = sentryService;
        this.configService = configService;
        this.ng1TranslateService = ng1TranslateService;
        this.calendlyService = calendlyService;
        this.survicateService = survicateService;
        this.languageService = languageService;
        this.store = store;
        this.alertPaymentService = alertPaymentService;
        this.amplitudeRouteListenerService = amplitudeRouteListenerService;
        this.leftMenuComponent = LeftMenuComponent;
        this.failPaid = false;
    }
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isChannelsDomain();
        this.replaceFavicon();
        this.progressColor = this.isChannelsDomain() ? '#23D99C' : 'red';
        this.sentryService.setInitialParams();
        this.calendlyService.initCalendly();
        this.survicateService.initTypeform();
        this.upgrade.bootstrap(document.body, [MODULE_NAME], { strictDi: true });
        this.$state = this.configService.getValue('$state');
        this.translateService.setDefaultLang('en');
        var selectedLanguage = this.languageService.selectLanguageBasedOnBrowserSettings();
        this.alertPaymentService.onActivatePaymentAlert.subscribe(function (isPaymentFailed) {
            _this.failPaid = isPaymentFailed;
        });
        this.alertPaymentService.onPaymentParamsFetch.subscribe(function (payment) {
            _this.payment = payment;
        });
        this.amplitudeRouteListenerService.startListening();
        this.store.select(getUserDetailsSelector).subscribe(function (details) {
            if (details && details.language) {
                _this.fetchTranslations(details.language);
            }
            else {
                _this.fetchTranslations(selectedLanguage);
            }
        });
    };
    AppComponent.prototype.isChannelsDomain = function () {
        return document.location.origin === environment.CHANNELS_URL || document.location.hostname.startsWith('localhost');
    };
    AppComponent.prototype.fetchTranslations = function (lng) {
        this.translateService.setTranslation('en', localEn);
        this.translateService.setTranslation('es', localEs);
        this.ng1TranslateService.setLang('en', localEn, lng);
        this.ng1TranslateService.setLang('es', localEs, lng);
        // if (environment.INTERNATIONALIZATION_URL) {
        //   forkJoin([this.languageService.getTranslation('en'), this.languageService.getTranslation('es')]).subscribe(
        //     ([en, es]: any) => {
        //       this.translate.setTranslation('en', en);
        //       this.translate.setTranslation('es', es);
        //
        //       this.ng1TranslateService.setLang('en', en, lng);
        //       this.ng1TranslateService.setLang('es', es, lng);
        //     }
        //   );
        // }
        this.translateService.setDefaultLang('en');
        this.useLanguage(lng);
    };
    AppComponent.prototype.isVisibleMenu = function () {
        return (this.$state && this.$state.current && this.$state.current.name && !this.$state.current.name.startsWith('accounts'));
    };
    AppComponent.prototype.useLanguage = function (lang) {
        this.ng1TranslateService.use(lang);
        this.languageService.use(lang);
        moment.locale(lang);
    };
    Object.defineProperty(AppComponent.prototype, "directPayment", {
        get: function () {
            try {
                return this.payment && this.payment.directPayment;
            }
            catch (e) {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    AppComponent.prototype.replaceFavicon = function () {
        var faviconElement = document.getElementById('favicon');
        var appleTouchIcon = document.getElementById('apple-touch-icon');
        var pageTitle = document.getElementById('page-title');
        var iconUrl = this.isChannelsDomain() ? '/assets/img/channels/favicon.png' : '/assets/img/favicon.png';
        faviconElement.setAttribute('href', iconUrl);
        appleTouchIcon.setAttribute('href', iconUrl);
        pageTitle.innerText = this.isChannelsDomain() ? 'Channels' : 'CrazyCall';
    };
    return AppComponent;
}());
export { AppComponent };
